"use client";

import { decodeAudioFile } from "mediatools";
import { baseName } from "../_components/format";
import type { MediaOperation } from "./types";

export const convertAudioOperation: MediaOperation<Record<string, never>> = {
  id: "convert-audio",
  group: "audio",
  inputKinds: ["audio"],
  outputKind: "audio",
  autoRun: true,
  defaultOptions: {},
  run: async (ctx) => {
    if (!ctx.file) throw new Error("No file selected.");
    const pcm = await decodeAudioFile(ctx.file);
    return { pcm, baseName: baseName(ctx.file.name), inputBytes: ctx.file.size };
  },
};
